import { classNames as joinClassNames } from "primereact/utils";

import styles from "./radio-group.module.scss";
import type { RadioGroupViewProps } from "./types-radio-group";

export function RadioGroupView({
  orientation,
  testId,
  className,
  style,
  rest,
  rootProps,
  children,
}: RadioGroupViewProps) {
  return (
    <div
      {...rootProps}
      className={joinClassNames(styles.root, className)}
      style={style}
      data-orientation={orientation}
      data-testid={testId}
      {...rest}
    >
      {children}
    </div>
  );
}
